import logo from '../../assets/img/logo.png';

import LoginFooter from '../../Component/Footer';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { forgetRequest, loginRequest } from "../../redux/actions/authAction";
import { IRootState } from '../../redux/reducer';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import { USERLIST } from "../../routes/routesConstant";

const NewSignin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // OTP input refs
  const otp1Ref = useRef<HTMLInputElement>(null);
  const otp2Ref = useRef<HTMLInputElement>(null);
  const otp3Ref = useRef<HTMLInputElement>(null);
  const otp4Ref = useRef<HTMLInputElement>(null);

  let emailData = "";
  let VarifiCodeData = "";
  const [emailActive, setemailActive] = useState(true);
  const [passwordActive, setPassword] = useState(true);
  const [verifyCodeActive, setVerifyCode] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passlError, setpassError] = useState(false);
  const [VarifiCodeError, setVarifiCodeError] = useState(false);
  const [capchaSelected, setCapchaSelected] = useState('')
  const [captchaError, setcaptchaError] = useState('null')
  const [error, setError] = useState('');
  const [btnLoading, setBtnLoading] = useState(false)
  const [resendOTPcodeLoading,setResendOTPcodeLoading] = useState(false)
  const [optRequired, setOtpRequired] = useState('')
  const [invalidOTP, setInvalidOTP] = useState('')
  const [emailPassError, setEmailPassError] = useState('')
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberme: true
  });
  const [otpSent, setOtpSent] = useState(false);
  const [otpValues, setOtpValues] = useState({
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: ''
  });

  const { loginData } = useSelector<IRootState, any>((state) => state.authReducer);
  const { forgetData } = useSelector<IRootState, any>((state) => state.authReducer);

  const isValidEmail = (email: any) => {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  };

  const loadCaptcha = () => {
    const captchaContainer = window.grecaptcha.render('captcha_container', {
      'sitekey': '6LeyGpopAAAAAJRjB_7MZwuvIVc0A2exj17o8W4A',
      'callback': function (response: any) {
        setCapchaSelected(response);
        setError('');
        setcaptchaError('false')
      }
    });
  };

  useEffect(() => {
    let timeOut = setTimeout(() => {
      loadCaptcha();
    }, 1000)

    return () => {
      clearTimeout(timeOut)
    }
  }, []);

  // OTP input handlers
  const handleOtpChange = (value: string, inputName: string, nextInputRef: React.RefObject<HTMLInputElement> | null) => {
    // Only allow numbers
    const numericValue = value.replace(/[^0-9]/g, '');
    
    if (numericValue.length <= 1) {
      setOtpValues(prev => ({
        ...prev,
        [inputName]: numericValue
      }));

      // Auto move to next input if current input has value and next input exists
      if (numericValue && nextInputRef && nextInputRef.current) {
        nextInputRef.current.focus();
      }
    }
  };

  const handleOtpKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, currentInputName: string, prevInputRef: React.RefObject<HTMLInputElement> | null, nextInputRef: React.RefObject<HTMLInputElement> | null) => {
    // Handle backspace - move to previous input if current is empty
    if (e.key === 'Backspace') {
      if (!otpValues[currentInputName as keyof typeof otpValues] && prevInputRef && prevInputRef.current) {
        e.preventDefault();
        prevInputRef.current.focus();
      }
    }
    
    // Handle arrow keys
    if (e.key === 'ArrowLeft' && prevInputRef && prevInputRef.current) {
      e.preventDefault();
      prevInputRef.current.focus();
    }
    
    if (e.key === 'ArrowRight' && nextInputRef && nextInputRef.current) {
      e.preventDefault();
      nextInputRef.current.focus();
    }
  };

  const handleSendOtp = async (e: React.MouseEvent) => {
    e.preventDefault();

    if (!formData.email) {
      setError('Please enter your email address');
      setEmailError(true);
      return;
    }

    if (!isValidEmail(formData.email)) {
      setError('Please enter a valid email address');
      setEmailError(true);
      return;
    }

    if (capchaSelected === '' || capchaSelected == '' || capchaSelected == 'true') {
      setcaptchaError('true')
      return false;
    } else {
      setcaptchaError('false')
    }

    try {
      setResendOTPcodeLoading(true)
           
      // Call the OTP request API
      const response = await axios.post(
        `https://www.darkroom.film/backend/api/v3/login?email=${encodeURIComponent(formData.email)}&is_parent=0&login_type=OTP`
      );

      if (response.data) {
        setOtpSent(true);
        setError('');
        setPassword(false);
        setVerifyCode(true);
        setemailActive(false);
        // Clear OTP values and focus on first input
        setOtpValues({
          otp1: '',
          otp2: '',
          otp3: '',
          otp4: ''
        });
        setTimeout(() => {
          if (otp1Ref.current) {
            otp1Ref.current.focus();
          }
        }, 100);
        toast.success('OTP sent successfully! Please check your email.');
      }
    } catch (error: any) {
      console.error('Error sending OTP:', error);
      const errorMessage = error.response?.data?.message || 'Failed to send OTP. Please try again.';
      setError(errorMessage);
      toast.error(errorMessage);
    }
    finally {
      setResendOTPcodeLoading(false)
    }
  };

  const verifyOtp = async (otp: string) => {
    setError('')
    setBtnLoading(prev => {
      console.log("Setting btnLoading from", prev, "to true");
      return true;
    });

    try {
      console.log('Verifying OTP...');
      // Call the OTP verification API
      const response = await axios.post(
        `https://www.darkroom.film/backend/api/v3/login?email=${encodeURIComponent(formData.email)}&is_parent=0&login_type=OTP&otp=${otp}`
      );

      console.log('OTP verification response:', response.data);

      if (response.data?.status_code === 1) {
        console.log('OTP verification successful');
        // Show success toast
        toast.success('OTP verified successfully! Logging you in...');

        // Format the response to match what the normal login flow returns
        const loginData = {
          rootUserDetail: {
            token: response.data.bearer_token,
            userToken: response.data.user_token,
            user_id: response.data.data.user_id,
          },
          token: response.data.bearer_token,
          ...response.data.data,
          userToken: response.data.user_token,
          message: response.data.message,
          status_code: response.data.status_code,
          accessType: 'login'
        };

        console.log('Formatted login data:', loginData);

        // Store tokens in localStorage (matching the normal login flow)
        localStorage.setItem('token', response.data.bearer_token);
        localStorage.setItem('user_token', response.data.user_token);
        localStorage.setItem('user', JSON.stringify(response.data.data));

        // Also store in sessionStorage for immediate access
        sessionStorage.setItem('token', response.data.bearer_token);
        sessionStorage.setItem('user_token', response.data.user_token);
        sessionStorage.setItem('user', JSON.stringify(response.data.data));

        // Set default axios headers with proper TypeScript types
        axios.defaults.headers = {
          ...axios.defaults.headers,
          common: {
            ...axios.defaults.headers?.common,
            'Authorization': `Bearer ${response.data.bearer_token}`,
            'User-Token': response.data.user_token,
            'X-Device': 'web',
            'X-Platform': 'browser'
          }
        } as any; // Type assertion to avoid TypeScript errors

        console.log('Dispatching login success action...');
        // Dispatch the success action with the same structure as normal login
        dispatch({
          type: 'GET_LOGIN_SUCCESS',
          data: loginData,
          accessType: 'login'
        });

        console.log('Waiting for state update...');
        // Add a small delay to ensure Redux state is updated
        await new Promise(resolve => setTimeout(resolve, 300));

        console.log('Navigating to user list...');
        // Redirect to user list
        navigate(USERLIST);
      } else {
        const errorMessage = response.data?.message || 'Failed to verify OTP';
        setError(errorMessage);
        setInvalidOTP(errorMessage)
        toast.error(errorMessage);
      }
    } catch (error: any) {
      console.error('Error verifying OTP:', error);
      const errorMessage = error.response?.data?.message || 'Invalid OTP. Please try again.';
      setError(errorMessage);
      toast.error(errorMessage);
    }
    finally {
      setBtnLoading(prev => {

        return false;
      });
    }
  };

  const signupFromSubmit = async (event: any) => {
    event.preventDefault();
    // console.log("signupFromSubmit called", event)
    // console.log("capchaSelected", capchaSelected)
    setOtpRequired('')
    setInvalidOTP('')
    
    // Handle OTP verification flow
    if (!emailActive && !passwordActive) {
      const otp = otpValues.otp1 + otpValues.otp2 + otpValues.otp3 + otpValues.otp4;

      if (otp.length !== 4) {
       
        setOtpRequired('Please enter a valid 4-digit code')
        setVarifiCodeError(true);
        setError('Please enter a valid 4-digit code');
        return;
      }

      if (capchaSelected === '' || capchaSelected == '' || capchaSelected == 'true') {
        setcaptchaError('true')
        return false;
      } else {
        setcaptchaError('false')
      }

      await verifyOtp(otp);
      return;
    } else {
     
      setBtnLoading(false);
    }

    // Handle normal login flow
    let message = '';
    if (!formData.email) {
      message = 'Please input email';
      setEmailError(true);
    } else if (!isValidEmail(formData.email)) {
      message = 'Please enter valid email!';
      setEmailError(true);
    } else {
      setEmailError(false);
    }

    if (!formData.password) {
      message = 'Please input password';
      setpassError(true);
    } else {
      setpassError(false);
    }

    if (message) {
      setError(message);
      return;
    } else {
      setError('');
    }

    if (capchaSelected === '' || capchaSelected == '') {
      setcaptchaError('true')
      return false;
    } else {
      setcaptchaError('false')
    }
    
    try {
      // Dispatch login action
      setBtnLoading(prev => {
        return true;
      });
      await dispatch(loginRequest(formData, 'login'));
    } catch (error) {
      console.error('Login failed:', error);
    } finally {

      // Set loading to false after completion (success or error)
      setBtnLoading(prev => {
        console.log("Setting btnLoading from", prev, "to false");
        return false;
      });
    }
  };

  const handleSendCode = async (e: React.MouseEvent) => {
    e.preventDefault();

    if (!formData.email) {
      setError('Please enter your email address');
      setEmailError(true);
      return;
    }

    if (!isValidEmail(formData.email)) {
      setError('Please enter a valid email address');
      setEmailError(true);
      return;
    }

    try {
      // Call the OTP API
      const response = await axios.post(
        `https://www.darkroom.film/backend/api/v3/login?email=${encodeURIComponent(formData.email)}&is_parent=0&login_type=OTP`
      );

      if (response.data) {
        // If API call is successful, switch to OTP input mode
        setPassword(!passwordActive);
        setVerifyCode(!verifyCodeActive);
        setemailActive(false);
        setError('');
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      setError('Failed to send OTP. Please try again.');
    }
  };

  const SignInCode = () => {
    if (formData.email && isValidEmail(formData.email)) {
      handleSendOtp({ preventDefault: () => { } } as React.MouseEvent);
      console.log("Send OTP formData.email && isValidEmail")
    } else {
      console.log("Else condition Send OTP formData.email && isValidEmail")
      setPassword(!passwordActive);
      setVerifyCode(!verifyCodeActive);
      setpassError(false)
    }
  }

  const usePassWord = () => {
    // Reset all form states to show email and password fields
    setPassword(true);           // Show password field
    setVerifyCode(false);        // Hide verify code field
    setemailActive(true);        // Show email field again
    setOtpSent(false);          // Reset OTP sent state

    // Clear any existing errors
    setError('');
    setEmailError(false);
    setpassError(false);
    setVarifiCodeError(false);

    // Reset form data completely (this will clear the email field visually)
    setFormData({
      email: "",               // Clear email
      password: "",            // Clear password
      rememberme: true
    });

    // Clear OTP values
    setOtpValues({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: ''
    });
  }

  useEffect(() => {
    if (loginData?.error?.toLowerCase() === "unauthenticated") {
      setError('Invalid Email or Password');
      setEmailPassError('Invalid Email or Password')
    } else if (loginData?.token && loginData?.accessType !== "signup") {
      toast(loginData?.message);
      navigate(`${USERLIST}`);
    }
  }, [loginData, navigate]);

  useEffect(() => {
    if (forgetData?.status_code) {
      toast(forgetData?.message);
    }
  }, [forgetData]);

  return (<>
    <div className="loginrgstr-page loginPage">
      <div className="login_main">
        <div className='login-header'>
          <div className='container-fluid'>
            <div className='login-main'>
              <div className="login-logo text-center">
                <a href="/"> <img src={logo} alt="" /></a>
              </div>
              <div className='loginheader-right'>
                <a className='btn login-btn' href='/signup'>Sign Up</a>
              </div>
            </div>
          </div>
        </div>
        <section className='loginrgstrform-section'>
          <div className='loginrgstr-maincover'>
            <div className='container'>
              <div className='loginrgstr-main'>
                <form onSubmit={signupFromSubmit} autoComplete="off">
                  <div className='loginscreen-area'>
                    {emailActive && <h1>Sign In</h1>}
                    {!emailActive && <h1>Enter the code we just sent</h1>}
                    {!emailActive && <p className="text-white pb-3" style={{ fontSize: '20px' }}>Please enter the 4-digit code sent to your registered email. Valid for 15 minutes.</p>}

                    <div className="form-grid">
                      {emailActive ? (
                        <div className="form-group">
                          <input
                            type="email"
                            placeholder="Email address"
                            name="email"
                            className="form-control"
                            value={formData.email}
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                            onKeyPress={(e) => { if (e.key === "Enter") { signupFromSubmit(e); } }}
                            autoComplete="new-email"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                          />
                          {emailError && <p className='text-danger text-left'>{error || 'Please fill in a valid email address'}</p>}
                          {!passwordActive && <p className='msgrated-text'>Message and data rates may apply</p>}
                        </div>
                      ) : null}

                      {!emailActive ? (
                        <>
                          <div className="form-group">
                            <div className='carifycodeinpt-grid'>
                              <input
                                ref={otp1Ref}
                                type="tel"
                                maxLength={1}
                                name="otp1"
                                className="form-control"
                                value={otpValues.otp1}
                                onChange={(e) => handleOtpChange(e.target.value, 'otp1', otp2Ref)}
                                onKeyDown={(e) => handleOtpKeyDown(e, 'otp1', null, otp2Ref)}
                                autoComplete="one-time-code"
                                autoCorrect="off"
                                autoCapitalize="off"
                                spellCheck="false"
                              />
                              <input
                                ref={otp2Ref}
                                type="tel"
                                maxLength={1}
                                name="otp2"
                                className="form-control"
                                value={otpValues.otp2}
                                onChange={(e) => handleOtpChange(e.target.value, 'otp2', otp3Ref)}
                                onKeyDown={(e) => handleOtpKeyDown(e, 'otp2', otp1Ref, otp3Ref)}
                                autoComplete="one-time-code"
                                autoCorrect="off"
                                autoCapitalize="off"
                                spellCheck="false"
                              />
                              <input
                                ref={otp3Ref}
                                type="tel"
                                maxLength={1}
                                name="otp3"
                                className="form-control"
                                value={otpValues.otp3}
                                onChange={(e) => handleOtpChange(e.target.value, 'otp3', otp4Ref)}
                                onKeyDown={(e) => handleOtpKeyDown(e, 'otp3', otp2Ref, otp4Ref)}
                                autoComplete="one-time-code"
                                autoCorrect="off"
                                autoCapitalize="off"
                                spellCheck="false"
                              />
                              <input
                                ref={otp4Ref}
                                type="tel"
                                maxLength={1}
                                name="otp4"
                                className="form-control"
                                value={otpValues.otp4}
                                onChange={(e) => handleOtpChange(e.target.value, 'otp4', null)}
                                onKeyDown={(e) => handleOtpKeyDown(e, 'otp4', otp3Ref, null)}
                                autoComplete="one-time-code"
                                autoCorrect="off"
                                autoCapitalize="off"
                                spellCheck="false"
                              />
                            </div>
                            {optRequired && <p className='text-danger text-left'>{optRequired}</p>}
                             {invalidOTP && (
                        <div className="form-group">
                          <p className='text-danger text-center'>{invalidOTP}</p>
                        </div>
                      )}
                          </div>
                        </>
                      ) : null}

                      {passwordActive ? (
                        <>
                          <div className="form-group">
                            <input
                              type="password"
                              placeholder="Password"
                              name="password"
                              className="form-control"
                              value={formData.password}
                              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                              onKeyPress={(e) => { if (e.key === "Enter") { signupFromSubmit(e); } }}
                              autoComplete="new-password"
                              autoCorrect="off"
                              autoCapitalize="off"
                              spellCheck="false"
                            />
                            {passlError && <p className='text-danger text-left'>{error || 'Please fill in a valid Password'}</p>}
                          </div>
                        </>
                      ) : null}

                       {
                        emailPassError && (
                          <div className="form-group">
                            <p className='text-danger text-center'>{emailPassError}</p>
                          </div>
                        )
                      }

                      <div className="form-group">
                        {!passwordActive && !otpSent ? (
                          <button
                            type="button"
                            className="btn w-100 text-center"
                            onClick={handleSendOtp}
                          >
                            Send sign-in code
                          </button>
                        ) : !passwordActive && otpSent ? (
                          
                          <button
                            type="submit"
                            className="btn w-100 text-center"
                            disabled={btnLoading} // disable while loading
                          >
                            {btnLoading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Verifying...
                              </>
                            ) : (
                              "Verify OTP"
                            )}
                          </button>

                        ) : (
                          <button
                            type="submit"
                            className="btn w-100 text-center"
                             disabled={btnLoading} // disable while loading
                          >
                            {btnLoading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Signing In...
                              </>
                            ) : (
                              "Sign In"
                            )}
                            
                          </button>
                        )}
                      </div>

                      <div className="form-group">
                        <p className='text-white text-center'>OR</p>
                      </div>

                      <div className="form-group">
                        {!emailActive && <p className='text-center didnotreceivecode-text'><strong>Did not receive a code?</strong></p>}
                        {passwordActive && (
                          <span onClick={SignInCode} className="btn w-100 text-center btn-signincode">
                            {passwordActive && <span>Use a sign-in code</span>}
                          </span>
                        )}

                        {!passwordActive && (
                          <span onClick={usePassWord} className="btn w-100 text-center btn-signincode">
                            {!passwordActive && <span>Use Password</span>}
                          </span>
                        )}

                      </div>

                      {!emailActive && <div className="form-group">
                        <span onClick={SignInCode} className="btn w-100 position-relative text-center btn-signincode loginsendcode-btn">
                          
                           {resendOTPcodeLoading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Resending Code...
                              </>
                            ) : (
                              "Resend Code"
                            )}
                        </span>
                      </div>}

                      {emailActive && <div className="form-group">
                        <div className="form-group">
                          <div className="custom-control custom-checkbox">
                            <input
                              className="custom-control-input"
                              type="checkbox"
                              id="Rememberme"
                              checked={formData.rememberme}
                              onChange={(e) => setFormData({ ...formData, rememberme: e.target.checked })}
                              autoComplete="off"
                            />
                            <label className="custom-control-label text-white" htmlFor="Rememberme">
                              Remember me
                            </label>
                          </div>
                        </div>
                      </div>}

                      {emailActive && <div className="form-group">
                        <p className='signup-text'><small>New to Darkroom?</small> <a href='/signup'> Sign up now.</a></p>
                      </div>}
                    </div>

                    {emailActive && <div className='recaptcha-text'>
                      <p>This page is protected by Google reCAPTCHA to ensure<br></br> you're not a bot.</p>
                      <div id="captcha_container" className="g-recaptcha custom-style d-flex justify-content-center"></div>
                    </div>}

                    {(captchaError === 'true') && (
                      <p className='text-danger text-center'>Please complete the captcha verification</p>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        <LoginFooter />
      </div>
    </div>
  </>)
}

export default NewSignin;